
import { Component, Vue } from "vue-property-decorator";
import { appColors, SessionStorageKey } from "../../common/AppConst";
import { Getter } from "vuex-class";
import {
  RootActionNames,
  RootGetterNames,
  RootMutationNames,
} from "@/vuex-store";
import { RouterTools } from "@/common/RouterTools";

@Component
export default class LeftNav extends Vue {
  readonly leftNavBgColor: string = appColors.primaryColor;
  readonly pageMenuItems = [
    {
      path: RouterTools.pagePaths.writing,
      title: "工作台",
      icon: "el-icon-monitor",
    },
    {
      path: "/check",
      title: "错别字检测",
      icon: "el-icon-edit-outline",
    },
    {
      path: RouterTools.pagePaths.aiCopywriter,
      title: "智能创作",
      icon: "el-icon-edit-outline",
    },
    {
      path: RouterTools.pagePaths.pay,
      title: "次数购买",
      icon: "el-icon-shopping-cart-2",
    },
    {
      path: "/customer",
      title: "客服",
      icon: "el-icon-phone-outline",
    },
  ];

  @Getter(RootGetterNames.isLogined)
  readonly isLogined!: boolean;

  get activePath() {
    return this.$route.path || "/writing";
  }

  //  点击登录选项
  clickLoginItem() {
    this.$store.commit(RootMutationNames.setShowLoginPanel, true);
  }

  // 退出
  async clickSignOutItem() {
    await this.$confirm("是否退出登录?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    sessionStorage.removeItem(SessionStorageKey.checkArticleId);
    await this.$store.dispatch(RootActionNames.logout);
  }
}
